import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Zap } from "lucide-react";

const serviceData = {
  id: "electricite",
  title: "Électricité",
  description: "Services électriques complets pour entreprises et industries",
  icon: Zap,
  image: "/Electricitebatiment.jpg", // Updated path
  longDescription: [
    "Notre équipe d'experts en électricité propose une gamme complète de services pour répondre à tous vos besoins électriques professionnels. De l'installation à la maintenance, nous assurons la sécurité et l'efficacité de vos installations.",
    "Nous intervenons dans tous types de bâtiments professionnels, avec une expertise particulière dans les environnements industriels et tertiaires.",
  ],
  features: [
    "Installation électrique complète",
    "Mise aux normes des installations",
    "Dépannage électrique 24/7",
    "Maintenance préventive et corrective",
    "Tableaux électriques et armoires de distribution",
    "Éclairage professionnel",
  ],
  benefits: [
    "Conformité aux normes de sécurité",
    "Optimisation de la consommation énergétique",
    "Intervention rapide en cas de panne",
    "Solutions adaptées à votre activité",
    "Maintenance régulière programmée",
  ],
};

const Electricite = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default Electricite;
